import { Button, Group, Modal, Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { Exhibitor } from 'api/dto/exhibitor'
import { Tradeshow } from 'api/dto/tradeshow'
import { useSendEmailExhibitor } from 'api/query/exhibitor'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

interface SendEmailExhibitorProps {
  opened: boolean
  onClose: () => void
  exhibitor?: Exhibitor
}

export function SendEmailExhibitor({ exhibitor, opened, onClose }: SendEmailExhibitorProps) {
  const { t } = useTranslation()
  const { tradeshowId } = useParams()
  const form = useForm<Tradeshow>({})
  const { mutateAsync: sendEmail } = useSendEmailExhibitor(tradeshowId!)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!opened) {
      form.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened])

  async function onSubmit() {
    if (!exhibitor?.id) {
      return
    }

    setSubmitting(true)
    await sendEmail(exhibitor.id)
    setSubmitting(false)
    onClose()
  }

  return (
    <Modal size="lg" opened={opened} onClose={onClose} title={t('exhibitor.send-email')}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Text size="15px">{t('exhibitor.email-are-you-sure-exhibitor', { replace: { name: exhibitor?.fullName } })}</Text>

        <Group mt={30} position="right">
          <Button disabled={submitting} variant="outline" size="xs" color="red" onClick={onClose}>
            {t('common.cancel')}
          </Button>

          <Button loading={submitting} size="xs" variant="outline" color="green" type="submit">
            {t('common.send')}
          </Button>
        </Group>
      </form>
    </Modal>
  )
}
